module.exports = "table {\n  width: 70%;\n  border-collapse: separate;\n  border-spacing: 1em; }\n\nth, td {\n  padding: 0 5px;\n  text-align: center; }\n\ntd :first-child {\n  text-align: left; }\n\n.price {\n  padding: 0; }\n\ntd.price {\n  margin: 0 20px; }\n\n.description {\n  width: 90%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-rows: auto auto auto;\n      grid-template-rows: auto auto auto;\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/peoplephone-siptrunk/peoplephone-siptrunk.component.scss
// module id = ./src/app/content/new-offer/peoplephone-siptrunk/peoplephone-siptrunk.component.scss
// module chunks = main